var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsHeroArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 483,
    viewBox: "0 0 332 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.857 -152L0.000970906 188.856L0.819272 189.674L0 190.494L108.301 297.156L126.145 314.999L126.281 314.863L297 483H331.5V269.706L251.469 189.675L467 -25.8565L340.857 -152Z",
    fill: "#373F68",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsHeroArrow);
export default __webpack_public_path__ + "static/media/about-us-hero-arrow.5833ae455051139c89fa2c8a693d414a.svg";
export { ForwardRef as ReactComponent };